"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = unavailableChoicesApiCall;
var _axios = _interopRequireDefault(require("axios"));
var _camelCase = _interopRequireDefault(require("../utils/camelCase"));
var _settings = require("../settings");
function unavailableChoicesApiCall(unavailableChoicesApiUrl, configuration, dispatch) {
  var _getSettings = (0, _settings.getSettings)(),
    unavailableChoicesApi = _getSettings.unavailableChoicesApi;
  if (typeof unavailableChoicesApi === 'string') {
    return (0, _axios["default"])({
      url: unavailableChoicesApi,
      data: configuration,
      method: 'post',
      crossDomain: true,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.data && response.data.Data.length > 0 ? (0, _camelCase["default"])(response.data.Data) : [];
    });
  } else if (typeof unavailableChoicesApi === 'function') {
    return unavailableChoicesApi(configuration, dispatch);
  }
  return Promise.resolve([]);
}
//# sourceMappingURL=unavailableChoicesApi.js.map